// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"f4684f02","899":"7759ef32"}[chunkId] + ".chunk.js";
};